import { createSlice } from "@reduxjs/toolkit"

import { generateSetPropReducer } from "../../../redux/shared/set-setate-prop.reducer.ts"
import { logout } from "../../LoginPage/redux/auth.thunks.ts"
import { RESULT_TYPES } from "../constants"
import {
  changeEmail,
  confirmEmail,
  fetchIdConfiguration,
  fetchUser,
  requestAccountDeletion,
  updateIdConfiguration,
  updatePassword,
  updateUser
} from "./settings.thunks"
import { type SettingsState } from "./settings.types.ts"

const initialState: SettingsState = {
  fetching: false,
  saveFetching: false,
  savePasswordFetching: false,
  deleteAccountFetching: false,

  user: null,
  saveResult: null,

  idConfiguration: null,
  idConfigurationFetching: false,
  idConfigurationSaving: false
}

const settingsSlice = createSlice({
  name: "settings",
  initialState,
  reducers: { setSettingsProp: generateSetPropReducer<SettingsState>() },
  extraReducers: (builder) => {
    builder
      // fetchUser
      .addCase(fetchUser.pending, (state) => {
        state.fetching = true
        state.user = null
      })
      .addCase(fetchUser.fulfilled, (state, action) => {
        state.fetching = false
        state.user = action.payload
      })
      .addCase(fetchUser.rejected, (state) => {
        state.fetching = false
      })

      // updateUser
      .addCase(updateUser.pending, (state) => {
        state.saveFetching = true
      })
      .addCase(updateUser.fulfilled, (state, action) => {
        const user = action?.payload

        state.saveFetching = false
        state.user = {
          ...(state.user ? { ...state.user } : {}),
          ...user
        }
        // state.saveResult = { type: RESULT_TYPES.USER_UPDATE }
      })
      .addCase(updateUser.rejected, (state) => {
        state.saveFetching = false
      })

      // updatePassword
      .addCase(updatePassword.pending, (state) => {
        state.savePasswordFetching = true
      })
      .addCase(updatePassword.fulfilled, (state, action) => {
        state.savePasswordFetching = false
        // state.saveResult = { type: RESULT_TYPES.PASSWORD_UPDATE }
      })
      .addCase(updatePassword.rejected, (state) => {
        state.savePasswordFetching = false
      })

      // changeEmail
      .addCase(changeEmail.pending, (state) => {
        state.saveFetching = true
      })
      .addCase(changeEmail.fulfilled, (state, action) => {
        state.saveFetching = false
        // state.saveResult = { type: RESULT_TYPES.EMAIL_UPDATE_REQUEST }
      })
      .addCase(changeEmail.rejected, (state) => {
        state.saveFetching = false
      })

      // confirmEmail
      .addCase(confirmEmail.pending, (state) => {
        state.saveFetching = true
      })
      .addCase(confirmEmail.fulfilled, (state, action) => {
        state.saveFetching = false
        state.saveResult = { type: RESULT_TYPES.EMAIL_UPDATE_CONFIRM }
      })
      .addCase(confirmEmail.rejected, (state) => {
        state.saveFetching = false
      })

      .addCase(requestAccountDeletion.pending, (state) => {
        state.deleteAccountFetching = true
      })
      .addCase(requestAccountDeletion.fulfilled, (state, action) => {
        state.deleteAccountFetching = false
        const user = action.payload
        if (user && state.user) {
          state.user = { ...state.user, ...user }
        } else if (user) {
          state.user = user as typeof state.user
        }
      })
      .addCase(requestAccountDeletion.rejected, (state) => {
        state.deleteAccountFetching = false
      })

      // fetchIdConfiguration
      .addCase(fetchIdConfiguration.pending, (state) => {
        state.idConfigurationFetching = true
      })
      .addCase(fetchIdConfiguration.fulfilled, (state, action) => {
        state.idConfigurationFetching = false
        state.idConfiguration = action.payload
      })
      .addCase(fetchIdConfiguration.rejected, (state) => {
        state.idConfigurationFetching = false
      })

      // updateIdConfiguration
      .addCase(updateIdConfiguration.pending, (state) => {
        state.idConfigurationSaving = true
      })
      .addCase(updateIdConfiguration.fulfilled, (state, action) => {
        state.idConfigurationSaving = false
        state.idConfiguration = action.payload
      })
      .addCase(updateIdConfiguration.rejected, (state) => {
        state.idConfigurationSaving = false
      })

      .addCase(logout.fulfilled, () => {
        console.log("settings logout")
        return initialState
      })
  }
})

export const { setSettingsProp } = settingsSlice.actions

export default settingsSlice
